import Paper from '../../shared/components/Paper/Paper';
import logo from '../../Icc_Logo.png';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userSignIn } from './login.api';
import { setAuthSession } from '../../utils/apiClient';

import Box from '../../shared/components/Box/Box';
import Input from '../../shared/components/Input/Input';
import Typography from '../../shared/components/Typography/Typography';
import Button from '../../shared/components/Button/Button';

function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSignIn = async () => {
    try {
      setError('');
      const authSession = await userSignIn({ email, password });
      setAuthSession(authSession);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Impossible de se connecter');
    }
  };

  return (
    <Box className="login-page">
      <Paper className="login-card">
        <Box className="login-logo">
          <img src={logo} className="App-logo" alt="logo" width="80%" objectFit="contain" />
        </Box>

        <Box className="login-form">
          <Typography variant="h5" mb={3} sx={{ color: 'var(--erp-primary)', fontWeight: 'bold', textAlign: 'center' }}>
            Connexion
          </Typography>

          <Input
            fullWidth
            label="Email"
            margin="normal"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />

          <Input
            fullWidth
            type="password"
            label="Password"
            margin="normal"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />

          {error && (
            <Typography color="error" variant="body2" sx={{ marginTop: 1 }}>
              {error}
            </Typography>
          )}

          <Button
            fullWidth
            variant="contained"
            sx={{ marginTop: 3, backgroundColor: 'var(--erp-primary)' }}
            onClick={handleSignIn}
          >
            Sign In
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default LoginPage;
